import { isRowingBlazers } from '../retailer';

export default function showPoweredByAspen() {
  return !isRowingBlazers();
}
